import styled from 'styled-components';

export const MessageError = styled.div`
  display: flex;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
  margin-top: 16px;
  color: #d10000;
  width: 324px;
  > svg {
    width: 20px;
    max-width: 20%;
    margin: auto 10px;
  }
  > p {
    max-width: 80%;
  }
  @media (max-width: 650px) {
    width: 298px;
    font-size: 13px;
    > svg {
      width: 17px;
    }
    > p {
      max-width: 70%;
    }
  }
`;

export const MessageWarn = styled.div`
  display: flex;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
  color: #bd5b00;
  > svg {
    width: 20px;
    max-width: 20%;
    margin: auto 10px;
  }
  > p {
    max-width: 80%;
  }
  @media (max-width: 650px) {
    font-size: 13px;
    > svg {
      width: 17px;
    }
    > p {
      max-width: 70%;
    }
  }
`;

export const MessageSuccess = styled.div`
  display: flex;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
  color: #008a00;
  > svg {
    width: 20px;
    max-width: 20%;
    margin: auto 10px;
  }
  > p {
    max-width: 80%;
  }
  @media (max-width: 650px) {
    font-size: 13px;
    > svg {
      width: 17px;
    }
    > p {
      max-width: 70%;
    }
  }
`;

export const MessageInfo = styled.div`
  display: flex;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
  color: #005cde;
  > svg {
    width: 20px;
    max-width: 20%;
    margin: auto 10px;
  }
  > p {
    max-width: 80%;
  }
  @media (max-width: 650px) {
    font-size: 13px;
    > svg {
      width: 17px;
    }
    > p {
      max-width: 70%;
    }
  }
`;
